var map = {
	"./default/disclaimer.html": 785,
	"./nl-BE/disclaimer.html": 789
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 464;



//////////////////
// WEBPACK FOOTER
// ./app/views/legal/partials disclaimer\.html$
// module id = 464
// module chunks = 10